import React from 'react';

import { H2 } from 'Elements/Typography';
import FlexBox from 'Elements/FlexBox';
import Arrow, { ArrowLinkProps } from 'Elements/Link/Arrow';

import Grid, { Col } from 'Components/Grid';

import IconLink, { IconButtonProps } from 'Campaigns/Clearing/Button/Icon';

import { landbot } from 'Layout/Main';

import {
    StyledSection,
    Wrapper,
    Container,
    Preheading,
    Heading,
    PostFooter,
    PhoneWrapper,
    LinksList,
    StyledListItem,
    Text,
    CopyContainer,
    PostHeading,
    DecorativeLines,
    PostFooterWrapper,
    Icon,
    DateLabel,
    DateText,
    ClearingClosedLinkWrapper,
    Location
} from './Footer.styled';

import { LinesOpen } from '../HeroBanner/HeroBanner.styled';

export interface Props {
    preHeading: string;
    heading: string;
    text?: string;
    isClearingOpen: boolean;
    phone: IconButtonProps;
    phoneOpeningTimes: string;
    contactLinks: (IconButtonProps & { id: string })[];
    signUpLink: IconButtonProps;
    postFooter?: {
        heading: string;
        text: string;
        dateLabel: string;
        date: string;
        link: ArrowLinkProps;
        location: string;
    };
    handleApplyModal?: () => void;
}

const Footer: React.FC<Props> = props => {
    const {
        heading,
        text,
        phone,
        phoneOpeningTimes,
        contactLinks,
        signUpLink,
        postFooter,
        isClearingOpen,
        preHeading,
        handleApplyModal
    } = props;

    const openChat = () => {
        landbot.open();
    };

    return (
        <StyledSection id="clearing-footer">
            <Grid>
                <Col l={[2, 12]}>
                    <Wrapper>
                        <DecorativeLines />
                        <Container $isClearingOpen={isClearingOpen}>
                            {isClearingOpen && (
                                <Preheading>
                                    <H2>{preHeading}</H2>
                                </Preheading>
                            )}
                            <div>
                                <Heading $textDefined={!!text} $isClearingOpen={isClearingOpen}>
                                    {heading}
                                </Heading>
                                {isClearingOpen && (
                                    <>
                                        {text && <Text>{text}</Text>}
                                        <PhoneWrapper>
                                            <IconLink {...phone} />
                                            <LinesOpen>{phoneOpeningTimes}</LinesOpen>
                                        </PhoneWrapper>
                                        <LinksList $hasOpenDay={postFooter ? true : false}>
                                            {contactLinks.map((item, index) => (
                                                <StyledListItem
                                                    key={item.id}
                                                    $firstItem={index === 0}
                                                >
                                                    <IconLink
                                                        {...item}
                                                        onClick={
                                                            index === 1
                                                                ? handleApplyModal
                                                                : index === 2
                                                                ? openChat
                                                                : undefined
                                                        }
                                                    />
                                                </StyledListItem>
                                            ))}
                                        </LinksList>
                                    </>
                                )}
                                {!isClearingOpen && (
                                    <ClearingClosedLinkWrapper>
                                        <IconLink {...signUpLink} />
                                    </ClearingClosedLinkWrapper>
                                )}
                            </div>
                        </Container>
                    </Wrapper>
                    {postFooter && (
                        <PostFooterWrapper>
                            <PostFooter $isClearingOpen={isClearingOpen}>
                                <CopyContainer>
                                    <PostHeading>{postFooter.heading}</PostHeading>
                                    <Text>{postFooter.text}</Text>
                                </CopyContainer>
                                <FlexBox alignItems="center">
                                    <Icon />
                                    <FlexBox direction="column" justifyContent="space-between">
                                        <DateLabel>{postFooter.dateLabel}</DateLabel>
                                        <DateText>{postFooter.date}</DateText>
                                        <div>
                                            <Location>{postFooter.location}</Location>
                                        </div>
                                    </FlexBox>
                                </FlexBox>
                                <Arrow {...postFooter.link} />
                            </PostFooter>
                        </PostFooterWrapper>
                    )}
                </Col>
            </Grid>
        </StyledSection>
    );
};

export default Footer;
